import { useState } from 'react';
import CustomTextAreaInput from '../../InputFields/CustomTextAreaInput';
import CustomTextInput from '../../InputFields/CustomTextInput';

const TextDataType = ({
  onDataChange,
  helpText,
  defaultValue,
}: {
  onDataChange: (updatedValues: { [key: string]: string }) => void;
  helpText: string;
  defaultValue: string;
}) => {
  const [formData, setFormData] = useState({
    helpText: helpText || '',
    defaultValue: defaultValue || '',
  });

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    const updatedFormData = { ...formData, [name]: value };

    setFormData(updatedFormData);

    onDataChange({ [name]: value });
  };

  return (
    <div className="ml-4">
      <CustomTextAreaInput
        label="Help Text"
        name="helpText"
        value={formData.helpText}
        onChange={handleInputChange}
        placeholder="Enter the description. i.e - This section provides key points of contact for communication and support."
        description="This will help in guiding the person filling this field."
        rows={12}
      />
      <div className="w-[360px] ">
        <CustomTextInput
          label="Default Value"
          name="defaultValue"
          value={formData.defaultValue}
          onChange={handleInputChange}
          className="text-ds-gray-500 font-semibold text-xs"
        />
      </div>
    </div>
  );
};

export default TextDataType;
